import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import ScrollToTop from "./ScrollToTop";
import "./App.css";
import "./component/css/style.css";
import "./component/css/common.css";
import "./component/css/theme.css";

import VisitorHome from "./pages/Visitors/VisitorHome";
import PackageDetails from "./pages/Visitors/PackageDetails";
import PackageDetailsTwo from "./pages/Visitors/PackageDetailsTwo";
import AllPackages from "./pages/Visitors/AllPackages";
import Contact from "./pages/Visitors/Contact";

import TestCode from "./pages/TestCode";

import VisitorHotelSearch from "./pages/Visitors/VisitorHotelSearch";
import VisitorHotelSearchResult from "./pages/Visitors/VisitorHotelSearchResult";
import VisitorHotelDetails from "./pages/Visitors/VisitorHotelDetails";
import VisitorHotelRoomBook from "./pages/Visitors/VisitorHotelRoomBook";
import VisitorHotelBookingFinalPage from "./pages/Visitors/VisitorHotelBookingFinalPage";
import VisitorHotelBookingConfirm from "./pages/Visitors/VisitorHotelBookingConfirm";

import VisitorFlightSearch from "./pages/Visitors/VisitorFlightBooking/VisitorFlightSearch";
import VisitorFlightSearchResult from "./pages/Visitors/VisitorFlightBooking/VisitorFlightSearchResult";
import VisitorFlightDetail from "./pages/Visitors/VisitorFlightBooking/VisitorFlightDetail";


import VisitorBusSearch from "./pages/Visitors/VisitorBusSearch";
// Agent 
import AgentLogin from "./pages/Agents/AgentLogin";
import ForgetPassword from "./pages/Agents/ForgetPassword";
import AgentDashboard from "./pages/Agents/AgentDashboard";
import FlightBook from "./pages/Agents/FlightBook";
import HotelBook from "./pages/Agents/HotelBook";
import BusBook from "./pages/Agents/BusBook";
import AgentAccount from "./pages/Agents/AgentAccount";
import AgentReport from "./pages/Agents/AgentReport/AgentReport";
import AgentChangePassword from "./pages/Agents/AgentChangePassword";
import AgentBookingReport from "./pages/Agents/AgentReport/AgentBookingReport";
import AgentAddMarkup from "./pages/Agents/AgentAddMarkup";
import FlightResult from "./pages/Agents/FlightResult";
import HotelResult from "./pages/Agents/HotelResult";
import HotelDetail from "./pages/Agents/HotelDetail";
import HotelRoomBook from "./pages/Agents/HotelRoomBook";
import FlightDetails from "./pages/Agents/FlightDetails";
import BusResult from "./pages/Agents/BusResult";
import MyWalletAgent from "./pages/Agents/MyWalletAgent";
import RequestTopUp from "./pages/Agents/RequestTopUp";
import AgentPins from "./pages/Agents/AgentPins";
import RechargeAgent from "./pages/Agents/RechargeAgent";
import RechargeMoneyTransfer from "./pages/Agents/RechargeMoneyTransfer";
import RechargeCreditCardBills from "./pages/Agents/RechargeCreditCardBills";
import RechargeDth from "./pages/Agents/RechargeDth";
import AgentFlightReport from "./pages/Agents/AgentReport/AgentFlightReport";
import AgentBusReport from "./pages/Agents/AgentReport/AgentBusReport";
import AgentDTHReport from "./pages/Agents/AgentReport/AgentDTHReport";
 import UpdateAgentPassword from "./pages/Agents/UpdateAgentPassword";

// Admin

import AdminDashboard from "./pages/Admin/AdminDashboard";
import BookingEnquiry from "./pages/Admin/BookingEnquiry";
import UserAgent from "./pages/Admin/UserAgent";
import AdminPackages from "./pages/Admin/AdminPackages";
import AdminProfile from "./pages/Admin/AdminProfile";
import SocialMedia from "./pages/Admin/SocialMedia";
import AdminBooking from "./pages/Admin/AdminBooking";
import AllStaff from "./pages/Admin/AllStaff";
import AdminBookingReport from "./pages/Admin/AdminReport/AdminBookingReport";
import AdminPasswordChange from "./pages/Admin/AdminPasswordChange";
import AdminLogin from "./pages/Admin/AdminLogin";
import AllFlightCode from "./pages/Admin/AllFlightCode";
import AllDistributors from "./pages/Admin/AllDistributors";
import EditDistributor from "./pages/Admin/AdminComp/EditDistributor";
import EditPackage from "./pages/Admin/AdminComp/EditPackage";
import AdminMarkup from "./pages/Admin/AdminMarkup";
import AdminHotelReport from "./pages/Admin/AdminReport/AdminHotelReport";
import AddPins from "./pages/Admin/AdminComp/AddPins";
import BookingEnquiryEdit from "./pages/Admin/BookingEnquiryEdit";
import HotelBookingAndMarkup from "./pages/Admin/AdminReport/HotelBookingAndMarkup";
import AdminAgentReport from "./pages/Admin/AdminReport/AdminAgentReport";
import AdminStateHeadReport from "./pages/Admin/AdminReport/AdminStateHeadReport";
import AdminStaffReport from "./pages/Admin/AdminReport/AdminStaffReport";
import AdminGstReport from "./pages/Admin/AdminReport/AdminGstReport";
import AdminFlightBookingReport from "./pages/Admin/AdminReport/AdminFlightBookingReport";
import AdminBusBookingReport from "./pages/Admin/AdminReport/AdminBusBookingReport";
import AdminCashbackReport from "./pages/Admin/AdminReport/AdminCashbackReport";
import AdminDthReport from "./pages/Admin/AdminReport/AdminDthReport";
import AdminMobileRechargeReport from "./pages/Admin/AdminReport/AdminMobileRechargeReport";
import AgentPaymentRequest from "./pages/Admin/AgentPaymentRequest";
import StateHeadPaymentRequest from "./pages/Admin/StateHeadPaymentRequest";




// Distributor 

import DistributorLogin from "./pages/Distributor/DistributorLogin";
import DistributorDashboard from "./pages/Distributor/DistributorDashboard";
import MyProfileDistributor from "./pages/Distributor/MyProfileDistributor";
import AddAgentDistributor from "./pages/Distributor/AddAgentDistributor";
import AllAgentDistributor from "./pages/Distributor/AllAgentDistributor";
import TransactionReport from "./pages/Distributor/TransactionReport";
import TransactionFlightReport from "./pages/Distributor/TransactionFlightReport";
import TransactionHotelReport from "./pages/Distributor/TransactionHotelReport";
import TransactionBusReport from "./pages/Distributor/TransactionBusReport";
import TransactionRechargeReport from "./pages/Distributor/TransactionRechargeReport";
import CommissionReport from "./pages/Distributor/CommissionReport";
import DistributorWallet from "./pages/Distributor/DistributorWallet";
import AddAgentTopup from "./pages/Distributor/AddAgentTopup";
import RequestAgent from "./pages/Distributor/RequestAgent";
import PinRequestByAgent from "./pages/Distributor/PinRequestByAgent";
import ResetPassword from "./pages/Distributor/ResetPassword";
import AddAmountRequest from "./pages/Distributor/AddAmountRequest";

function App() {
  return (
    <Router>
      <div className="App">
        <main>
          {/* ScrollToTop component ensures scrolling to the top on route change */}
          <ScrollToTop />

          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            {/* Visitor routes  */}
            <Route path="/" element={<VisitorHome />} />
            {/* <Route path="/package" element={<PackageDetails />} /> */}
            <Route path="/package-detail/:slug" element={<PackageDetailsTwo />} />
            <Route path="/all-package" element={<AllPackages />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/search-hotel" element={<VisitorHotelSearch />} />
            <Route path="/search-hotel-result" element={<VisitorHotelSearchResult />} />
            <Route path="/search-hotel-result-details" element={<VisitorHotelDetails />} />
            <Route path="/hotel-booking-room" element={<VisitorHotelRoomBook />} />
            <Route path="/hotel-booking-checkout" element={<VisitorHotelBookingFinalPage />} />
            <Route path="/confirm-hotel-booking/:orderid" element={<VisitorHotelBookingConfirm />} />

            <Route path="/flight-search-visitor" element={<VisitorFlightSearch />} />
            <Route path="/flight-search-result" element={<VisitorFlightSearchResult />} />
            <Route path="/flight-details/:token" element={<VisitorFlightDetail />} />

            <Route path="/bus-search" element={<VisitorBusSearch />} />
            
            <Route path="/test" element={<TestCode />} />
            
            {/* Agent */}
            <Route path="/login" element={<AgentLogin />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/agent-dashboard" element={<AgentDashboard />} />
            <Route path="/flight-booking" element={<FlightBook />} />
            <Route path="/hotel-booking" element={<HotelBook />} />
            <Route path="/bus-booking" element={<BusBook />} />
            <Route path="/my-profile" element={<AgentAccount />} />
            <Route path="/my-reports" element={<AgentReport />} />
            <Route path="/change-password" element={<AgentChangePassword />} />
            <Route path="/booking-report" element={<AgentBookingReport />} />
            <Route path="/add-markup" element={<AgentAddMarkup />} />
            <Route path="/flight-result" element={<FlightResult />} />
            <Route path="/hotel-result" element={<HotelResult />} />
            <Route path="/hotel-details" element={<HotelDetail />} />
            <Route path="/book-room" element={<HotelRoomBook />} />
            <Route path="/flight-detail/:token" element={<FlightDetails />} />
            <Route path="/bus-result" element={<BusResult />} />
            <Route path="/agent/my-wallet" element={<MyWalletAgent />} />
            <Route path="/agent/request-top-up" element={<RequestTopUp />} />
            <Route path="/agent/my-pins" element={<AgentPins />} />
            <Route path="/agent/recharge" element={<RechargeAgent />} />
            <Route path="/agent/money-transfer" element={<RechargeMoneyTransfer />} />
            <Route path="/agent/credit-card-bill" element={<RechargeCreditCardBills />} />
            <Route path="/agent/dth-recharge" element={<RechargeDth />} />
            <Route path="/agent/flight-report" element={<AgentFlightReport />} />
            <Route path="/agent/bus-report" element={<AgentBusReport />} />
            <Route path="/agent/dth-report" element={<AgentDTHReport />} />
            <Route path="/update-agent-password/:userid" element={<UpdateAgentPassword />} />
            
            
            {/* admin */}

            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/booking-enquiry" element={<BookingEnquiry />} />
            <Route path="/user-agents" element={<UserAgent />} />
            <Route path="/admin-packages" element={<AdminPackages />} />
            <Route path="/admin-profile" element={<AdminProfile />} />
            <Route path="/social-links" element={<SocialMedia />} />
            <Route path="/admin-booking" element={<AdminBooking />} />
            <Route path="/all-staff" element={<AllStaff />} />
            <Route path="/admin-booking-report" element={<AdminBookingReport />} />
            <Route path="/admin-change-password" element={<AdminPasswordChange />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/add-flight-code" element={<AllFlightCode />} />
            <Route path="/add-distributors" element={<AllDistributors />} />
            <Route path="/edit-distributor/:id" element={<EditDistributor />} />
            <Route path="/edit-package/:id" element={<EditPackage />} />
            <Route path="/add-admin-markup/" element={<AdminMarkup />} />
            <Route path="/admin-hotel-booking-report/" element={<AdminHotelReport />} />
            <Route path="/add-pins/:id" element={<AddPins />} />
            <Route path="/admin/edit-booking/:id" element={<BookingEnquiryEdit />} />
            <Route path="/admin/hotel-markup" element={<HotelBookingAndMarkup />} />
            <Route path="/admin/agent-report" element={<AdminAgentReport />} />
            <Route path="/admin/state-head-report" element={<AdminStateHeadReport />} />
            <Route path="/admin/staff-report" element={<AdminStaffReport />} />
            <Route path="/admin/gst-report" element={<AdminGstReport />} />
            <Route path="/admin/admin-flight-report" element={<AdminFlightBookingReport />} />
            <Route path="/admin/admin-bus-report" element={<AdminBusBookingReport />} />
            <Route path="/admin/admin-cashback-report" element={<AdminCashbackReport />} />
            <Route path="/admin/admin-dth-report" element={<AdminDthReport />} />
            <Route path="/admin/admin-mobile-report" element={<AdminMobileRechargeReport />} />
            <Route path="/admin/agent-payment-request" element={<AgentPaymentRequest />} />
            <Route path="/admin/state-head-payment-request" element={<StateHeadPaymentRequest />} />
            
            
            

            <Route path="/distributor-login" element={<DistributorLogin />} />
            <Route path="/distributor-dashboard" element={<DistributorDashboard />} />
            <Route path="/distributor/my-profile" element={<MyProfileDistributor />} />
            <Route path="/distributor/add-agent" element={<AddAgentDistributor />} />
            <Route path="/distributor/all-agent" element={<AllAgentDistributor />} />
            <Route path="/distributor/transaction-report" element={<TransactionReport />} />
            <Route path="/distributor/flight-report" element={<TransactionFlightReport />} />
            <Route path="/distributor/hotel-report" element={<TransactionHotelReport />} />
            <Route path="/distributor/bus-report" element={<TransactionBusReport />} />
            <Route path="/distributor/recharge-report" element={<TransactionRechargeReport />} />
            <Route path="/distributor/commission-report" element={<CommissionReport />} />
            <Route path="/state-head/my-wallet" element={<DistributorWallet />} />
            <Route path="/state-head/agent-topup/:agent_id" element={<AddAgentTopup />} />
            <Route path="/state-head/top-up-request" element={<RequestAgent />} />
            <Route path="/state-head/pin-request" element={<PinRequestByAgent />} />
            <Route path="/state-head-password/email/:encoded" element={<ResetPassword />} />
            <Route path="/state-head/top-up-req" element={<AddAmountRequest />} />
            
            
            
            
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
